export const downIndicator = () => (
  <>
    <path
      d="M2 8L14 20L26 8"
      stroke="currentColor"
      stroke-width="2.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </>
)
